import { Component, Input, EventEmitter, OnInit, Output } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-banker-group-modal-loan',
  templateUrl: './banker-group-modal-loan.component.html',
  styleUrls: ['./banker-group-modal-loan.component.scss']
})
export class BankerGroupModalLoanComponent implements OnInit {

  public loans: any = [];
  @Input() player_uuid: string;
  @Input() type: string;
  @Output() closeEvent = new EventEmitter<boolean>();
  constructor(private http: HttpService) { }

  ngOnInit(): void {
    this.init();
  }
  async init() {
    let rtn:any = await this.http.post("/admin/banker-group/get-loan", {player_uuid: this.player_uuid, type: this.type});
    if(!rtn.status) {
      this.http.notify(rtn.message);
      return;
    }
    this.loans = rtn.loans;
  }

}
